export { default } from './TextMPCWithImageContainer';
